var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSquaresFour = function SvgSquaresFour(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#64748B",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.25,
    d: "M18.586 25.414C19.172 26 20.114 26 22 26s2.828 0 3.414-.586S26 23.886 26 22s0-2.828-.586-3.414S23.886 18 22 18s-2.828 0-3.414.586S18 20.114 18 22s0 2.828.586 3.414M6.586 13.414C7.172 14 8.114 14 10 14s2.828 0 3.414-.586S14 11.886 14 10s0-2.828-.586-3.414S11.886 6 10 6s-2.828 0-3.414.586S6 8.114 6 10s0 2.828.586 3.414M18.586 13.414C19.172 14 20.114 14 22 14s2.828 0 3.414-.586S26 11.886 26 10s0-2.828-.586-3.414S23.886 6 22 6s-2.828 0-3.414.586S18 8.114 18 10s0 2.828.586 3.414M6.586 25.414C7.172 26 8.114 26 10 26s2.828 0 3.414-.586S14 23.886 14 22s0-2.828-.586-3.414S11.886 18 10 18s-2.828 0-3.414.586S6 20.114 6 22s0 2.828.586 3.414"
  })));
};
export default SvgSquaresFour;